<template>
  <vs-sidebar position-right default-index="1" color="secondary" class="sidebarx" v-model="isActive" id="calcBar">

    <vs-row vs-type="flex" vs-w="12" class="p-3">
      <vs-row vs-type="flex" vs-w="12">
        <div class="w-full calc-screen friendly-border px-5 py-1">
          <vs-row vs-type="flex" vs-w="12">
            <vs-row vs-type="flex" vs-w="12" vs-justify="flex-start">
              <p class="bold calc-screen-selected-price">{{$toCurrency(totalPrice)}} -</p>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" vs-justify="flex-end">
              <p class="bold calc-screen-entry-price">{{enteredPrice}}</p>
            </vs-row>
          </vs-row>
        </div>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12">
        <vs-col vs-type="flex" vs-w="7" vs-offset="0.5">
          <vs-button type="gradient" color="primary" class="sale-box-shadow bold w-full friendly-border mt-3"
            @click="clearEnteredPrice">Temizle
          </vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-w="3.5" vs-offset="0.5">
          <vs-button type="gradient" icon-pack="feather" icon="icon-arrow-left" color="primary"
            class="sale-box-shadow bold w-full friendly-border mt-3" @click="clearLastChar">
          </vs-button>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" vs-justify="space-between" class="mt-3 px-3">
        <vs-col vs-type="flex" vs-w="3.8" vs-justify="center" v-for="rate in rates" :key="rate.id">
          <vs-button size="large" type="gradient" color="primary" @click="spliceTotalPrice(rate.value)"
            class="w-full px-0 sale-box-shadow bold half-friendly-border" style="font-size:1rem!important;">
            {{rate.name}}
          </vs-button>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="center">
        <vs-col vs-type="flex" vs-w="4" v-for="number in numbers" :key="number" vs-justify="center" vs-align="center">
          <vs-button type="flat" color="secondary" class="number my-1 py-5 sale-box-shadow bold half-friendly-border"
            @click="appendNumber(number)">
            {{number}}
          </vs-button>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12">
        <vs-col vs-type="flex" vs-w="8">
          <vs-button type="flat" color="secondary" class="w-full my-1 py-5 mx-1 sale-box-shadow bold half-friendly-border"
            @click="enterZero">
            0
          </vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-w="4">
          <vs-button type="flat" color="secondary" class="w-full my-1 py-5 mx-1 sale-box-shadow bold half-friendly-border"
            @click="enterComma">
            ,
          </vs-button>
        </vs-col>
      </vs-row>
      <vs-button :disabled="enteredPriceStr == ''" color="transparent"
        class="py-3 bg-success text-white sale-box-shadow bold w-full friendly-border mt-3"
        style="font-size:1.5rem!important;" @click="approvePayment">Onayla
      </vs-button>
    </vs-row>
    <vs-row class="payments" vs-w="3">
      <select-payment-type ref="selectPaymentType" @dontClose="doNotCloseCalc = true" :dontCloseCalc="true"
        :currentDate="currentDate" :currentTime="currentTime" />
    </vs-row>
  </vs-sidebar>
</template>

<script>
  import SelectPaymentType from './SelectPaymentType.vue';
  export default {
    data() {
      return {
        doNotCloseCalc: false,
        payTypes: [],
        numbers: ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
        isActive: false,
        rates: [{
            id: 1,
            value: 4,
            name: "1/4"
          },
          {
            id: 2,
            value: 3,
            name: "1/3"
          },
          {
            id: 3,
            value: 2,
            name: "1/2"
          }
        ],
        enteredPriceStr: "",
        enteredPrice: 0
      };
    },
    props: {
      currentTime: {
        type: String,
        required: true
      },
      currentDate: {
        type: String,
        required: true
      },
      totalPrice: {
        type: Number,
        required: true

      }
    },
    components: {
      SelectPaymentType
    },
    watch: {
      payTypes: {
        deep: true,
        handler(val) {
          this.$refs.selectPaymentType.payTypes = val;
        }
      },
      isActive: function (val, oldVal) {
        if (oldVal == true && val == false && this.doNotCloseCalc == true) {
          this.$nextTick(() => {
            this.isActive = oldVal
            this.doNotCloseCalc = false;
          });
        }
      },
      enteredPriceStr: function (newVal, oldVal) {
        if (parseFloat(newVal.replace(",", ".")) > this.totalPrice) {
          this.enteredPriceStr = oldVal;
        } else if(this.enteredPriceStr == ""){
          this.enteredPrice = 0;
        } else {
          this.enteredPrice = this.enteredPriceStr;
        }
      }
    },
    methods: {
      savePaymentMethod(val) {
        this.$emit("savePaymentMethod", val);
      },
      spliceTotalPrice(rate) {
        this.enteredPriceStr = "";
        let value = this.totalPrice / rate;
        value = value.toFixed(2);
        value = value.replace(".", ",");
        this.enteredPriceStr = value;
      },
      clearLastChar: function () {
        this.enteredPriceStr = this.enteredPriceStr.substring(0, this.enteredPriceStr.length - 1);
      },
      doPay: function () {
        this.$emit("doPay", null);
      },
      closeEvent: function () {
        this.$emit("closeCalculatorPage", false);
      },
      appendNumber: function (str) {
        this.enterPriceData(str);
      },
      clearEnteredPrice: function () {
        this.enteredPriceStr = "";
      },
      enterComma: function () {
        this.enterPriceData(",");
      },
      enterZero: function () {
        this.enterPriceData("0");
      },
      approvePayment: function () {
        this.$emit("setIsPieced");
        this.$emit("doPay", parseFloat(this.enteredPrice.replace(",", ".")));
        this.enteredPriceStr = "";
      },
      enterPriceData: function (val) {

        if (this.enteredPriceStr.includes(",")) {
          let split = this.enteredPriceStr.split(",");
          if (split[1].length > 1) {
            return;
          }
        }
        if (val === ",") {
          if (!this.enteredPriceStr.includes(",")) {
            if (this.enteredPriceStr.length === 0) {
              this.enteredPriceStr = this.enteredPriceStr + "0" + val;
            } else {
              this.enteredPriceStr = this.enteredPriceStr + val;
            }

          }
        } else if (val === "0") {
          if (this.enteredPriceStr.length > 0) {
            this.enteredPriceStr = this.enteredPriceStr + val;
          } else {
            return;
          }
        } else {
          this.enteredPriceStr = this.enteredPriceStr + val;
        }
      }
    }
  };

</script>

<style>
  .payments {
    position: absolute;
    top: 15vh;
    left: -8.3rem;
    border-top-left-radius: 1rem;
    border-top-right-radius: 0;
    border-bottom-left-radius: 1rem;
    border-bottom-right-radius: 0;
  }

  #calcBar .vs-sidebar {
    height: 630px !important;
    background: transparent linear-gradient(180deg, #FFFFFF 0%, #F1F1F1 100%) 0% 0% no-repeat padding-box !important;
    top: calc(50% - 315px);
    border-top-left-radius: 3rem;
    border-top-right-radius: 0;
    border-bottom-left-radius: 3rem;
    border-bottom-right-radius: 0;
    max-width: 300px !important;
  }

  #calcBar .vs-sidebar .vs-sidebar--items {
    border-radius: 3rem !important;
  }

  .calc-screen {
    background: #F2F2F2 0% 0% no-repeat padding-box;
    border: 1px solid #7070709E;
    height: fit-content;
  }

  .calc-screen-selected-price {
    color: #bebebe;
    font-size: 1rem !important;
  }

  .calc-screen-entry-price {
    color: #868686;
    font-size: 1.5rem !important;
  }

  .number:focus {
    color: white;
    background: rgb(106, 31, 19);
  }

  .number {
    padding-left: 35px !important;
    padding-right: 35px !important;
    font-size: 1.4rem !important;
  }

</style>
